import React, { useState } from 'react';
import { Button, Card, Col, Form as FormAnt, message, Row, Select } from 'antd';
import { DatePicker, Space } from 'antd';
import { useParams } from 'react-router-dom';
import { useVehicleSearch } from '../../../../../../../../Hooks/TT_ELD/Logs';
import { companies } from '../../../../../../../../API/TT_ELD/Users/company';

interface Params {
  [key: string]: string | undefined;

  id: string | undefined;
}

const IftaGenerate = () => {
  const [form] = FormAnt.useForm();
  const { id } = useParams<Params>();
  const vehicleData: any = useVehicleSearch('', id);
  const [loadings, setLoadings] = useState<boolean[]>([]);
  const enterLoading = (index: number) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });

    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 6000);
  };

  const onSubmit = async (value: any) => {
    if (!value.vehiclesIds) {
      message.error('Please select vehicles');
      return;
    }

    try {
      message.loading({ content: 'Processing...', key: 'regenerate' });

      const year = value.date.year();
      const month = Number((value.date.month() + 1).toString().padStart(2, '0'));

      const vehicleIds = value.vehiclesIds.includes('all')
        ? vehicleData?.data?.data?.map((v: any) => v.id)
        : value.vehiclesIds;

      const body = {
        year,
        month,
        companyId: Number(id),
        vehicleIds,
        type: value.type,
      };

      const res = await companies.regenerate(body);

      message.success({
        content: 'Report regenerated successfully!',
        key: 'regenerate',
      });

      console.log('Response:', res);
    } catch (err: any) {
      message.error({
        content: err?.response?.data?.message || 'Something went wrong!',
        key: 'regenerate',
      });

      console.error('Regenerate Error:', err);
    }
  };

  return (
    <Card>
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <FormAnt
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{ modifier: 'public' }}
          onFinish={onSubmit}
        >
          <Row gutter={[16, 10]}>
            <Col xs={24} sm={24} md={12} lg={4}>
              <FormAnt.Item
                name="date"
                label="Date range"
                rules={[{ required: true, message: 'Please enter your date!' }]}
              >
                <DatePicker picker="month" />
              </FormAnt.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={4}>
              <FormAnt.Item
                name="type"
                label="Report Type"
                rules={[{ required: true, message: 'Please select report type!' }]}
              >
                <Select
                  placeholder="Select report type"
                  options={[
                    { label: 'Log', value: 'log' },
                    { label: 'Tracking', value: 'vehicle' },
                  ]}
                />
              </FormAnt.Item>
            </Col>
          </Row>
          <Row gutter={[16, 10]}>
            <Col xs={24} sm={24} md={12} lg={8}>
              <FormAnt.Item
                name="vehiclesIds"
                label="Vehicles"
                rules={[{ required: true, message: 'Please enter your vehicles!' }]}
              >
                <Select
                  allowClear
                  mode="multiple"
                  style={{ width: '100%' }}
                  placeholder="Please select"
                  onChange={(vals) => {
                    if (vals.includes('all')) {
                      form.setFieldsValue({ vehiclesIds: ['all'] });
                    } else {
                      form.setFieldsValue({ vehiclesIds: vals });
                    }
                  }}
                  filterOption={(input, option: any) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  options={[
                    ...(vehicleData?.data?.data?.length > 0
                      ? [{ label: 'All', value: 'all' }]
                      : []),
                    ...(vehicleData?.data?.data?.map((option: any) => ({
                      value: option.id,
                      label: option.truck_number,
                    })) ?? []),
                  ]}
                />
              </FormAnt.Item>
            </Col>
          </Row>

          <FormAnt.Item>
            <Button
              onClick={() => enterLoading(1)}
              loading={loadings[1]}
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </FormAnt.Item>
        </FormAnt>
      </Space>
    </Card>
  );
};

export default IftaGenerate;
